import React from "react";
import Select from "../../../forms/Select";
import "./style.css";

const EditMenu = (props) => {
  const errors = props.errors || {};
  const setErrors = props.setErrors || (() => {});

  const isValidUrl = (string) => {
    try {
      const url = new URL(string);
      return url.protocol === "https:";
    } catch (_) {
      return false;
    }
  };

  const handleToggleEnable = (index) => {
    const updatedMenus = props.menuData.map((menu, i) =>
      i === index ? { ...menu, enabled: !menu.enabled } : menu
    );
    props.setMenuData(updatedMenus);
  };

  const handleValueChange = (index, value, propertyName) => {
    if (propertyName === "url") {
      if (value && !isValidUrl(value)) {
        setErrors((prev) => ({ ...prev, [index]: { ...prev[index], url: "Enter a valid URL" } }));
      } else {
        setErrors((prev) => {
          const newErrors = { ...prev };
          if (newErrors[index]) {
            delete newErrors[index].url;
            if (Object.keys(newErrors[index]).length === 0) delete newErrors[index];
          }
          return newErrors;
        });
      }
    }
    if (propertyName === "TemplateId") {
      if (!value || !props.templateListOptions.some(option => option.value === value)) {
        setErrors((prev) => ({ ...prev, [index]: { ...prev[index], TemplateId: "Please select a valid template" } }));
      } else {
        setErrors((prev) => {
          const newErrors = { ...prev };
          if (newErrors[index]) {
            delete newErrors[index].TemplateId;
            if (Object.keys(newErrors[index]).length === 0) delete newErrors[index];
          }
          return newErrors;
        });
      }
    }
    if (propertyName === "pageName" || propertyName === "displayName") {
      if (!value.trim()) {
        setErrors((prev) => ({ ...prev, [index]: { ...prev[index], [propertyName]: `${propertyName === "pageName" ? "Page Name" : "Display Name"} is required` } }));
      } else {
        const emojiRegex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF\uD83D\uDE00-\uDE4F])/g;
        const scriptRegex = /<script>|<iframe>|<embed>|<object>|<link>|<img>|<svg>|<textarea>|<meta>|<form>|\bscript\b|\bonerror\b|\bonload\b|\bonclick\b|\bonmouseover\b|\bsrc\b|\bhref\b|%3cscript%3e|%3ciframe%3e|%3cembed%3e|%3cobject%3e|%3clink%3e|%3cimg%3e|%3csvg%3e|%3ctextarea%3e|%3cmeta%3e|%3cform%3e/g;
        if (emojiRegex.test(value) || scriptRegex.test(value)) {
          setErrors((prev) => ({ ...prev, [index]: { ...prev[index], [propertyName]: "Special characters are not allowed" } }));
        } else {
          setErrors((prev) => {
            const newErrors = { ...prev };
            if (newErrors[index]) {
              delete newErrors[index][propertyName];
              if (Object.keys(newErrors[index]).length === 0) delete newErrors[index];
            }
            return newErrors;
          });
        }
      }
    }
    const updatedMenus = props.menuData.map((menu, i) =>
      i === index ? { ...menu, [propertyName]: value } : menu
    );
    props.setMenuData(updatedMenus);
  };

  const handleAddExternalRow = () => {
    const newMenu = {
      type: "External Site",
      pageName: "",
      displayName: "",
      enabled: false,
      url: "",
    };
    props.setMenuData([...props.menuData, newMenu]);
  };

  const handleAddStaticRow = () => {
    const newMenu = {
      type: "Static Site",
      pageName: "",
      displayName: "",
      enabled: false,
      TemplateId: "",
    };
    props.setMenuData([...props.menuData, newMenu]);
  };

  const handleDelete = (index) => {
    const updatedMenus = props.menuData.filter((_, i) => i !== index);
    props.setMenuData(updatedMenus);
    // Remove errors for the deleted index and shift higher indices
    const newErrors = { ...errors };
    delete newErrors[index];
    // Shift errors for higher indices
    Object.keys(newErrors).forEach(key => {
      const numKey = parseInt(key,10);
      if (numKey > index) {
        newErrors[numKey - 1] = newErrors[numKey];
        delete newErrors[numKey];
      }
    });
    setErrors(newErrors);
  };

  return (
    <div className="col-12">
      <div>
        <h3>Internal Menu</h3>
        <div className="row">
          <div className="col-12 col-xl-12">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th className="column-header small-font">Page Name</th>
                    <th className="column-header small-font">Menu Text</th>
                    <th className="column-header small-font">
                      Enable / Disable
                    </th>
                    <th className="column-header small-font">URL / Template</th>
                  </tr>
                </thead>
                <tbody>
                  {props.menuData.map(
                    (menu, idx) =>
                      menu.type === "Internal Site" && (
                        <tr key={idx}>
                          <td className="item-cell small-font">
                            {menu.pageName}
                          </td>
                          <td className="item-cell small-font">
                            <input
                              type="text"
                              value={menu.displayName || ""}
                              name={`displayName-${idx}`}
                              onChange={(e) =>
                                handleValueChange(
                                  idx,
                                  e.target.value,
                                  "displayName"
                                )
                              }
                            />
                            {errors[idx] && errors[idx].displayName && (
                              <div className="error-message">
                                {errors[idx].displayName}
                              </div>
                            )}
                          </td>
                          <td className="item-cell small-font">
                            <input
                              type="checkbox"
                              checked={menu.enabled}
                              name={`enableCheckBox-${idx}`}
                              onChange={() => handleToggleEnable(idx)}
                            />
                          </td>
                          <td className="item-cell small-font">
                            {menu.url}
                          </td>
                        </tr>
                      )
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div>
        <h3>External Menu</h3>
        <div className="row">
          <div className="col-12 col-xl-12">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th className="column-header small-font">Page Name</th>
                    <th className="column-header small-font">Menu Text</th>
                    <th className="column-header small-font">
                      Enable / Disable
                    </th>
                    <th className="column-header small-font">URL / Template</th>
                    <th className="column-header small-font">Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {props.menuData.map(
                    (menu, idx) =>
                      (menu.type === "External Site" ||
                        menu.type === "Static Site") && (
                        <tr key={idx}>
                          <td className="item-cell small-font">
                            <input
                              type="text"
                              name={`pageName-${idx}`}
                              value={menu.pageName || ""}
                              onChange={(e) =>
                                handleValueChange(
                                  idx,
                                  e.target.value,
                                  "pageName"
                                )
                              }
                            />
                            {errors[idx] && errors[idx].pageName && (
                              <div className="error-message">
                                {errors[idx].pageName}
                              </div>
                            )}
                          </td>
                          <td className="item-cell small-font">
                            <input
                              type="text"
                              name={`displayName-${idx}`}
                              value={menu.displayName || ""}
                              onChange={(e) =>
                                handleValueChange(
                                  idx,
                                  e.target.value,
                                  "displayName"
                                )
                              }
                            />
                            {errors[idx] && errors[idx].displayName && (
                              <div className="error-message">
                                {errors[idx].displayName}
                              </div>
                            )}
                          </td>
                          <td
                            className="item-cell small-font"
                            style={{ textAlign: "center" }}
                          >
                            <input
                              type="checkbox"
                              name={`enableCheckBox-${idx}`}
                              checked={menu.enabled}
                              onChange={() => handleToggleEnable(idx)}
                            />
                          </td>
                          <td className="item-cell small-font">
                            {menu.type === "External Site" && (
                              <div>
                                <input
                                  type="text"
                                  name={`url-${idx}`}
                                  value={menu.url}
                                  onChange={(e) =>
                                    handleValueChange(
                                      idx,
                                      e.target.value,
                                      "url"
                                    )
                                  }
                                />
                                {errors[idx] && errors[idx].url && (
                                  <div className="error-message">
                                    {errors[idx].url}
                                  </div>
                                )}
                              </div>
                            )}
                            {menu.type === "Static Site" && (
                              <div>
                                <Select
                                  searchable
                                  clearable={false}
                                  field={{
                                    name: "TemplateId",
                                    value:
                                      props.templateListOptions.find(
                                        (option) =>
                                          option.value === menu.TemplateId
                                      ) || "",
                                    rules: {
                                      title: "TemplateId",
                                      required: true,
                                    },
                                  }}
                                  validate={() => {}}
                                  options={props.templateListOptions}
                                  onChange={(selected) =>
                                    handleValueChange(
                                      idx,
                                      selected ? selected : "",
                                      "TemplateId"
                                    )
                                  }
                                />
                                {errors[idx] && errors[idx].TemplateId && (
                                  <div className="error-message">
                                    {errors[idx].TemplateId}
                                  </div>
                                )}
                              </div>
                            )}
                          </td>
                          <td
                            className="item-cell small-font"
                            style={{ textAlign: "center" }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="30"
                              height="24"
                              fill="red"
                              class="bi bi-trash"
                              viewBox="0 0 16 16"
                              style={{ cursor: "pointer" }}
                              title="Delete"
                              onClick={() => handleDelete(idx)}
                            >
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                              <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                            </svg>
                          </td>
                        </tr>
                      )
                  )}
                </tbody>
              </table>
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <button className="btn btn-primary" onClick={handleAddStaticRow}>
                + Add Static Site Tab
              </button>
              <button
                className="btn btn-primary"
                onClick={handleAddExternalRow}
              >
                + Add External Site Tab
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditMenu;



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Menu Management/EditMenu.js